import React from 'react'

import { Route, Switch } from 'react-router-dom'
import BrandBasedRoute from '@components/auth/BrandBasedRoute'
import AssemblerRoute from '@components/auth/AssemblerRoute'

import PageWithSidebar from './containers/markups/PageWithSidebar'
import IndexPage from './containers/IndexPage'
import MakeOrderPage from './containers/order/MakeOrderPage'
import NotFoundPage from './containers/NotFoundPage'
import OrdersPage from './containers/order/OrdersPage'
import CatalogPage from './containers/catalog/CatalogPage'
import EditOrderPage from './containers/order/EditOrderPage'
import ViewOrderPage from './containers/order/ViewOrderPage'
import BrandSettingsPage from './containers/BrandSettingsPage'
import CatalogProductPage from './containers/catalog/CatalogProductPage'
import CatalogExportPage from './containers/catalog/CatalogExportPage'
import ShopsPage from './containers/shop/ShopsPage'
import EditShopPage from './containers/shop/EditShopPage'
import ShopSlotsPage from './containers/shop/ShopSlotsPage'
import EditShopSlotPage from './containers/shop/EditShopSlotPage'
import AssemblingOrderAssemblePage from './containers/order/AssemblingOrderAssemblePage'
import AssemblersManagementPage from './containers/assembling/assemblers/AssemblersManagementPage'
import AssemblingSettingsPage from './containers/assembling/settings/AssemblingSettingsPage'
import CatalogCategoriesPage from './containers/catalog/CatalogCategoriesPage'
import UsersManagementPage from './containers/staff/UsersManagementPage'
import UsersManagementFormPage from './containers/staff/UsersManagementFormPage'
import CatalogCategoryPage from './containers/catalog/CatalogCategoryPage'
import MarketingManagementPage from './containers/marketing/MarketingManagementPage'
import AssemblingManagementPage from './containers/assembling/AssemblingManagementPage'
import SettingsPage from './containers/SettingsPage'
import MenusPage from './containers/settings/MenusPage'
import MenuEditPage from './containers/settings/MenuEditPage'
import MenuItemsPage from './containers/settings/MenuItemsPage'
import PromocodeFormPage from './containers/marketing/promocode/PromocodeFormPage'
import BannerFormPage from './containers/marketing/banner/BannerFormPage'
import BannerTypeFormPage from './containers/marketing/banner/BannerTypeFormPage'
import StoryFormPage from './containers/marketing/stories/StoryFormPage'
import CustomersPage from './containers/customer/CustomersPage'
import ViewCustomerPage from './containers/customer/ViewCustomerPage'
import CustomerFormPage from './containers/customer/CustomerFormPage'
import ManageNoPhotoProducts from './containers/catalog/ManageNoPhotoProducts'
import OrderReceiptFix from './containers/order/OrderReceiptFix'
import LabelFormPage from './containers/marketing/label/LabelFormPage'
import LoyaltyCouponSeriesFormPage from './containers/marketing/loyaltyCoupons/LoyaltyCouponSeriesFormPage'
import ProductReviewsPage from 'containers/catalog/ProductReviewsPage'
import ProductReviewFormPage from './containers/catalog/ProductReviewFormPage'
import ProductReviewModerationFormPage from './containers/catalog/ProductReviewModerationFormPage'
import ReportsPage from './containers/report/ReportsPage'
import TopologyPage from './containers/settings/topology/TopologyPage'
import CountryFormPage from './containers/settings/topology/CountryFormPage'
import RegionFormPage from './containers/settings/topology/RegionFormPage'
import CityFormPage from './containers/settings/topology/CityFormPage'

/*
  Guard for brand based routes
*/

import {
  ROUTE_INDEX,
  ROUTE_ANY,
  ROUTE_CATALOG,
  ROUTE_CATALOG_EXPORT,
  ROUTE_CATALOG_PRODUCT_ADD,
  ROUTE_CATALOG_PRODUCT_EDIT,
  ROUTE_CATALOG_CATEGORIES,
  ROUTE_CATALOG_CATEGORY_ADD,
  ROUTE_CATALOG_CATEGORY_EDIT,
  ROUTE_ORDERS_CREATE_ORDER,
  ROUTE_ORDERS,
  ROUTE_ORDERS_EDIT_ORDER,
  ROUTE_ORDERS_VIEW_ORDER,
  ROUTE_BRAND_SETTINGS,
  ROUTE_SHOPS,
  ROUTE_SHOPS_EDIT_SHOP,
  ROUTE_ASSEMBLING_MANAGEMENT,
  ROUTE_USERS_MANAGEMENT,
  ROUTE_USERS_MANAGEMENT_ADD,
  ROUTE_USERS_MANAGEMENT_EDIT,
  ROUTE_CUSTOMERS,
  ROUTE_CUSTOMERS_ADD_CUSTOMER,
  ROUTE_CUSTOMERS_EDIT_CUSTOMER,
  ROUTE_CUSTOMERS_VIEW_CUSTOMER,
  ROUTE_MARKETING_MANAGEMENT,
  ROUTE_MARKETING_PROMOCODE_ADD,
  ROUTE_MARKETING_PROMOCODE_EDIT,
  ROUTE_SETTINGS,
  ROUTE_SETTINGS_MENUS,
  ROUTE_SETTINGS_MENUS_CREATE,
  ROUTE_SETTINGS_MENUS_EDIT,
  ROUTE_SETTINGS_MENU_ITEMS,
  ROUTE_SETTINGS_MENU_ITEMS_CREATE,
  ROUTE_SETTINGS_MENU_ITEMS_EDIT,
  ROUTE_SETTINGS_TOPOLOGY,
  ROUTE_SETTINGS_TOPOLOGY_COUNTRY_CREATE,
  ROUTE_SETTINGS_TOPOLOGY_COUNTRY_EDIT,
  ROUTE_SETTINGS_TOPOLOGY_REGION_CREATE,
  ROUTE_SETTINGS_TOPOLOGY_REGION_EDIT,
  ROUTE_SETTINGS_TOPOLOGY_CITY_CREATE,
  ROUTE_SETTINGS_TOPOLOGY_CITY_EDIT,
  ROUTE_SHOPS_SLOTS,
  ROUTE_SHOPS_EDIT_SLOT,
  ROUTE_MARKETING_BANNER_ADD,
  ROUTE_MARKETING_BANNER_EDIT,
  ROUTE_MARKETING_STORIES_ADD,
  ROUTE_MARKETING_STORIES_EDIT,
  ROUTE_UTIL_PRODUCT_PREVIEW_ADD,
  ROUTE_UTIL_ORDER_RECEIPT_FIX,
  ROUTE_MARKETING_LABEL_ADD,
  ROUTE_MARKETING_LABEL_EDIT,
  ROUTE_MARKETING_LOYALTY_COUPON_ADD,
  ROUTE_MARKETING_LOYALTY_COUPON_EDIT,
  ROUTE_MARKETING_BANNER_TYPE_ADD,
  ROUTE_MARKETING_BANNER_TYPE_EDIT,
  ROUTE_ORDERS_FEEDBACKS,
  ROUTE_CATALOG_PRODUCT_REVIEWS,
  ROUTE_CATALOG_PRODUCT_REVIEW_EDIT,
  ROUTE_CATALOG_MODERATION_PRODUCT_REVIEWS,
  ROUTE_BUSINESS_PROFILES,
  ROUTE_EDIT_BUSINESS_PROFILE,
  ROUTE_ORDERS_ON_MAP,
  ROUTE_DELIVERY_ZONES,
  ROUTE_DELIVERY_ZONES_ON_MAP,
  ROUTE_DELIVERY_ZONES_EDIT,
  ROUTE_DELIVERY_ZONES_CREATE,
  ROUTE_MODERATE_BUSINESS_PROFILES,
  ROUTE_SHOPS_CREATE_SHOP,
  ROUTE_PRODUCT_GROUPS,
  ROUTE_PRODUCT_GROUPS_ADD,
  ROUTE_PRODUCT_GROUPS_EDIT,
  ROUTE_PRODUCT_ATTRIBUTES,
  ROUTE_PRODUCT_ATTRIBUTES_ADD,
  ROUTE_PRODUCT_ATTRIBUTES_EDIT,
  ROUTE_TEXT_MATERIALS_MANAGEMENT,
  ROUTE_TEXT_MATERIALS_CATEGORIES,
  ROUTE_TEXT_MATERIALS_CATEGORIES_ADD,
  ROUTE_TEXT_MATERIALS_CATEGORIES_EDIT,
  ROUTE_TEXT_MATERIALS_ADD,
  ROUTE_TEXT_MATERIALS_EDIT,
  ROUTE_TEXT_MATERIALS_THEMES,
  ROUTE_TEXT_MATERIALS_THEMES_ADD,
  ROUTE_DELIVERY_ZONES_LIST,
  ROUTE_LOGISTIC_DASHBOARD,
  ROUTE_LOGISTIC_SHIFTS_PLANNER,
  ROUTE_MAIN_PAGE_CONFIGS,
  ROUTE_MAIN_PAGE_CONFIGS_EDIT,
  ROUTE_MAIN_PAGE_CONFIGS_ADD,
  ROUTE_REPORTS,
  ROUTE_TEXT_MATERIALS_THEMES_EDIT,
  ROUTE_DEVICES,
  ROUTE_STORAGE_CONTAINERS,
  ROUTE_STORAGE_CONTAINERS_CREATE,
  ROUTE_STORAGE_CONTAINERS_EDIT,
  ROUTE_CATALOG_CATEGORY_ORDER,
  ROUTE_CATALOG_CATEGORY_TREE,
  ROUTE_LOGISTIC_COURIERS,
  ROUTE_LOGISTIC_VEHICLES,
  ROUTE_LOGISTIC_VEHICLES_SINGLE,
  ROUTE_SHOP_TAGS,
  ROUTE_SHOP_TAGS_EDIT,
  ROUTE_SHOP_TAGS_CREATE,
  ROUTE_SHOPS_FEEDBACKS,
  ROUTE_LOGISTIC_SLOTS,
  ROUTE_LOGISTIC_EDIT_SLOT
} from '@@partner:config/routes'
import OrdersFeedbacksPage from 'containers/order/OrdersFeedbacksPage'
import BusinessProfilesPage from 'containers/businessProfile/BusinessProfilesPage'
import BusinessProfileFormPage from 'containers/businessProfile/BusinessProfileFormPage'
import ActiveOrdersOnMapPage from 'containers/order/ActiveOrdersOnMapPage'
import DeliveryZonePage from 'containers/logistic/deliveryZone/DeliveryZonePage'
import DeliveryZonesOnMapPage from 'containers/logistic/deliveryZone/DeliveryZonesOnMapPage'
import DeliveryZoneEditPage from 'containers/logistic/deliveryZone/DeliveryZoneEditPage'
import WaitingCheckBusinessProfilesForm from '@components/businessProfiles/WaitingCheckBusinessProfilesForm'
import WaitingCheckBusinessProfilesFormPage from 'containers/businessProfile/WaitingCheckBusinessProfilesFormPage'
import CatalogProductGroupsPage from 'containers/catalog/CatalogProductGroupsPage'
import ProductGroupPage from 'containers/catalog/ProductGroupPage'
import ProductAttributesPage from 'containers/catalog/ProductAttributesPage'
import SingleProductAttributePage from 'containers/catalog/SingleProductAttributePage'
import TextMaterialManagementPage from 'containers/textMaterial/TextMaterialManagementPage'
import TextMaterialCategoriesPage from 'containers/textMaterial/category/TextMaterialCategoriesPage'
import TextMaterialCategoryFormPage from 'containers/textMaterial/category/TextMaterialCategoryFormPage'
import TextMaterialFormPage from 'containers/textMaterial/TextMaterialFormPage'
import TextMaterialThemesPage from 'containers/textMaterial/theme/TextMaterialThemesPage'
import TextMaterialThemeFormPage from 'containers/textMaterial/theme/TextMaterialThemeFormPage'
import LogisticDashboard from 'containers/logistic/LogisticDashboardPage'
import DeliveryZonesPage from 'containers/logistic/deliveryZone/DeliveryZonesPage'
import ShiftsPlanner from 'containers/logistic/shifts/ShiftsPlanner'
import MainPageConfigsPage from 'containers/marketing/mainPageConfig/MainPageConfigsPage'
import MainPageConfigFormPage from 'containers/marketing/mainPageConfig/MainPageConfigFormPage'
import DevicesPage from 'containers/device/DevicesPage'
import StorageContainersPage from 'containers/storageContainer/StorageContainersPage'
import CreateStorageContainerPage from 'containers/storageContainer/CreateStorageContainerPage'
import EditStorageContainerPage from 'containers/storageContainer/EditStorageContainerPage'
import CatalogCategoriesOrderPage from 'containers/catalog/CatalogCategoriesOrderPage'
import CatalogCategoriesTreePage from 'containers/catalog/CatalogCategoriesTreePage'
import { usePartner } from '@@partner:helpers/hooks/auth'
import CouriersManagementPage from 'containers/logistic/couriers/CouriersManagementPage'
import VehiclesPages from 'containers/logistic/vehicle/VehiclesPage'
import SingleVehiclePage from 'containers/logistic/vehicle/SingleVehiclePage'
import ShopTagsPage from 'containers/shop/shopTag/ShopTagsPage'
import EditShopTagPage from 'containers/shop/shopTag/EditShopTagPage'
import ShopFeedbacksPage from 'containers/shop/shopFeedback/ShopFeedbacksPage'
import DeliverySlotsPage from 'containers/logistic/slots/DeliverySlotsPage'
import EditDeliverySlotPage from 'containers/logistic/slots/EditDeliverySlotPage'

export default function AppRouterSwitch () {
  const {
    partnerInfo
  } = usePartner()

  const canViewBlock = (permission: string) => !partnerInfo.settings?.permissions || partnerInfo.settings?.permissions.includes(permission)
  return (
    <Switch>
      <Route path={ROUTE_INDEX} exact>
        <PageWithSidebar>
          <IndexPage />
        </PageWithSidebar>
      </Route>

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_CATALOG} exact>
          <PageWithSidebar>
            <CatalogPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_CATALOG_EXPORT} exact>
          <PageWithSidebar>
            <CatalogExportPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_PRODUCT_GROUPS} exact>
          <PageWithSidebar>
            <CatalogProductGroupsPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute 
          path={[
            ROUTE_PRODUCT_GROUPS_ADD,
            ROUTE_PRODUCT_GROUPS_EDIT
          ]} exact>
          <PageWithSidebar>
            <ProductGroupPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_PRODUCT_ATTRIBUTES} exact>
          <PageWithSidebar>
            <ProductAttributesPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute 
          path={[
            ROUTE_PRODUCT_ATTRIBUTES_ADD,
            ROUTE_PRODUCT_ATTRIBUTES_EDIT
          ]} 
          exact
        >
          <PageWithSidebar>
            <SingleProductAttributePage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_CATALOG_CATEGORIES} exact>
          <PageWithSidebar>
            <CatalogCategoriesPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute
          path={[ ROUTE_CATALOG_CATEGORY_ADD, ROUTE_CATALOG_CATEGORY_EDIT ]}
          exact
        >
          <PageWithSidebar>
            <CatalogCategoryPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_CATALOG_CATEGORY_ORDER} exact>
          <PageWithSidebar>
            <CatalogCategoriesOrderPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_CATALOG_CATEGORY_TREE} exact>
          <PageWithSidebar>
            <CatalogCategoriesTreePage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute
          path={[ ROUTE_CATALOG_PRODUCT_ADD, ROUTE_CATALOG_PRODUCT_EDIT ]}
          exact
        >
          <PageWithSidebar>
            <CatalogProductPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      {/* hided create order page */}
      {/* <BrandBasedRoute path={ROUTE_ORDERS_CREATE_ORDER} exact>
        <PageWithSidebar>
          <MakeOrderPage />
        </PageWithSidebar>
      </BrandBasedRoute> */}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_CATALOG_PRODUCT_REVIEWS} exact>
          <PageWithSidebar>
            <ProductReviewsPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_CATALOG_PRODUCT_REVIEW_EDIT} exact>
          <PageWithSidebar>
            <ProductReviewFormPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('catalog') && (
        <BrandBasedRoute path={ROUTE_CATALOG_MODERATION_PRODUCT_REVIEWS} exact>
          <PageWithSidebar>
            <ProductReviewModerationFormPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('orders') && (
        <BrandBasedRoute path={ROUTE_ORDERS_EDIT_ORDER} exact>
          <PageWithSidebar>
            <EditOrderPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('orders') && (
        <BrandBasedRoute path={ROUTE_ORDERS_VIEW_ORDER} exact>
          <PageWithSidebar>
            <ViewOrderPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('orders') && (
        <BrandBasedRoute path={ROUTE_ORDERS} exact>
          <PageWithSidebar>
            <OrdersPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('orders') && (
        <BrandBasedRoute path={ROUTE_ASSEMBLING_MANAGEMENT} exact>
          <PageWithSidebar>
            <AssemblingManagementPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('orders') && (
        <BrandBasedRoute path={ROUTE_ORDERS_FEEDBACKS} exact>
          <PageWithSidebar>
            <OrdersFeedbacksPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('orders') && (
        <BrandBasedRoute path={ROUTE_ORDERS_ON_MAP} exact>
          <PageWithSidebar>
            <ActiveOrdersOnMapPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('settings') && (
        <BrandBasedRoute path={ROUTE_BRAND_SETTINGS} exact>
          <PageWithSidebar>
            <BrandSettingsPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('shops') && (
        <BrandBasedRoute path={ROUTE_SHOPS} exact>
          <PageWithSidebar>
            <ShopsPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('shops') && (
        <BrandBasedRoute path={ROUTE_SHOPS_FEEDBACKS} exact>
          <PageWithSidebar>
            <ShopFeedbacksPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_DELIVERY_ZONES_LIST} exact>
          <PageWithSidebar>
            <DeliveryZonesPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_DELIVERY_ZONES_ON_MAP} exact>
          <PageWithSidebar>
            <DeliveryZonesOnMapPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_DELIVERY_ZONES_EDIT} exact>
          <PageWithSidebar>
            <DeliveryZoneEditPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_DELIVERY_ZONES_CREATE} exact>
          <PageWithSidebar>
            <DeliveryZoneEditPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_LOGISTIC_DASHBOARD} exact>
          <PageWithSidebar>
            <LogisticDashboard />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_LOGISTIC_EDIT_SLOT} exact>
          <PageWithSidebar>
            <EditDeliverySlotPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_LOGISTIC_SLOTS} exact>
          <PageWithSidebar>
            <DeliverySlotsPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_LOGISTIC_COURIERS} exact>
          <PageWithSidebar>
            <CouriersManagementPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_LOGISTIC_SHIFTS_PLANNER} exact>
          <PageWithSidebar>
            <ShiftsPlanner />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_LOGISTIC_VEHICLES} exact>
          <PageWithSidebar>
            <VehiclesPages />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('logistics') && (
        <BrandBasedRoute path={ROUTE_LOGISTIC_VEHICLES_SINGLE} exact>
          <PageWithSidebar>
            <SingleVehiclePage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}
      

      { canViewBlock('shops') && (
        <BrandBasedRoute path={ROUTE_SHOPS_EDIT_SHOP} exact>
          <PageWithSidebar>
            <EditShopPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}
      
      { canViewBlock('shops') && (
        <BrandBasedRoute path={ROUTE_SHOPS_CREATE_SHOP} exact>
          <PageWithSidebar>
            <EditShopPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('shops') && (
        <BrandBasedRoute path={ROUTE_SHOPS_SLOTS} exact>
          <PageWithSidebar>
            <ShopSlotsPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('shops') && (
        <BrandBasedRoute path={ROUTE_SHOPS_EDIT_SLOT} exact>
          <PageWithSidebar>
            <EditShopSlotPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('shopTags') && (
        <BrandBasedRoute path={ROUTE_SHOP_TAGS} exact>
          <PageWithSidebar>
            <ShopTagsPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('shops') && (
        <BrandBasedRoute path={[ ROUTE_SHOP_TAGS_EDIT, ROUTE_SHOP_TAGS_CREATE ]} exact>
          <PageWithSidebar>
            <EditShopTagPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      <Route path={ROUTE_UTIL_PRODUCT_PREVIEW_ADD} exact>
        <PageWithSidebar>
          <ManageNoPhotoProducts />
        </PageWithSidebar>
      </Route>

      <Route path={ROUTE_UTIL_ORDER_RECEIPT_FIX} exact>
        <PageWithSidebar>
          <OrderReceiptFix />
        </PageWithSidebar>
      </Route>

      { canViewBlock('customers') && (
        <Route path={ROUTE_CUSTOMERS} exact>
          <PageWithSidebar>
            <CustomersPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('customers') && (
        <Route path={[ ROUTE_CUSTOMERS_VIEW_CUSTOMER ]} exact>
          <PageWithSidebar>
            <ViewCustomerPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('customers') && (
        <Route
          path={[ ROUTE_CUSTOMERS_ADD_CUSTOMER, ROUTE_CUSTOMERS_EDIT_CUSTOMER ]}
          exact
        >
          <PageWithSidebar>
            <CustomerFormPage />
          </PageWithSidebar>
        </Route>
      )}
      
      { canViewBlock('businessProfiles') && (
        <Route
          path={[ ROUTE_BUSINESS_PROFILES ]}
          exact
        >
          <PageWithSidebar>
            <BusinessProfilesPage />
          </PageWithSidebar>
        </Route>
      )}
      
      { canViewBlock('businessProfiles') && (
        <Route
          path={[ ROUTE_EDIT_BUSINESS_PROFILE ]}
          exact
        >
          <PageWithSidebar>
            <BusinessProfileFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('businessProfiles') && (
        <BrandBasedRoute 
          path={[ ROUTE_MODERATE_BUSINESS_PROFILES ]} 
          exact
        >
          <PageWithSidebar>
            <WaitingCheckBusinessProfilesFormPage />
          </PageWithSidebar>
        </BrandBasedRoute>
      )}

      { canViewBlock('users') && (
        <Route path={ROUTE_USERS_MANAGEMENT} exact>
          <PageWithSidebar>
            <UsersManagementPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('users') && (
        <Route path={[ ROUTE_USERS_MANAGEMENT_ADD, ROUTE_USERS_MANAGEMENT_EDIT ]}>
          <PageWithSidebar>
            <UsersManagementFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route path={ROUTE_MARKETING_MANAGEMENT} exact>
          <PageWithSidebar>
            <MarketingManagementPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('reports') && (
        <Route path={ROUTE_REPORTS} exact>
          <PageWithSidebar>
            <ReportsPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('textMaterials') && (
        <Route path={ROUTE_TEXT_MATERIALS_MANAGEMENT} exact>
          <PageWithSidebar>
            <TextMaterialManagementPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('textMaterials') && (
        <Route path={ROUTE_TEXT_MATERIALS_ADD} exact>
          <PageWithSidebar>
            <TextMaterialFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('textMaterials') && (
        <Route path={ROUTE_TEXT_MATERIALS_EDIT} exact>
          <PageWithSidebar>
            <TextMaterialFormPage />
          </PageWithSidebar>
        </Route>
      )}

      
      
      { canViewBlock('textMaterials') && (
        <Route path={ROUTE_TEXT_MATERIALS_CATEGORIES} exact>
          <PageWithSidebar>
            <TextMaterialCategoriesPage />
          </PageWithSidebar>
        </Route>
      )}
      
      { canViewBlock('textMaterials') && (
        <Route path={[ ROUTE_TEXT_MATERIALS_CATEGORIES_ADD, ROUTE_TEXT_MATERIALS_CATEGORIES_EDIT ]} exact>
          <PageWithSidebar>
            <TextMaterialCategoryFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('textMaterials') && (
        <Route path={ROUTE_TEXT_MATERIALS_THEMES} exact>
          <PageWithSidebar>
            <TextMaterialThemesPage />
          </PageWithSidebar>
        </Route>
      )}
      
      { canViewBlock('textMaterials') && (
        <Route path={[ ROUTE_TEXT_MATERIALS_THEMES_ADD, ROUTE_TEXT_MATERIALS_THEMES_EDIT ]} exact>
          <PageWithSidebar>
            <TextMaterialThemeFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route
          path={[ ROUTE_MARKETING_PROMOCODE_ADD, ROUTE_MARKETING_PROMOCODE_EDIT ]}
          exact
        >
          <PageWithSidebar>
            <PromocodeFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route
          path={[ ROUTE_MARKETING_BANNER_ADD, ROUTE_MARKETING_BANNER_EDIT ]}
          exact
        >
          <PageWithSidebar>
            <BannerFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route
          path={[
            ROUTE_MARKETING_BANNER_TYPE_ADD,
            ROUTE_MARKETING_BANNER_TYPE_EDIT
          ]}
          exact
        >
          <PageWithSidebar>
            <BannerTypeFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route
          path={[ ROUTE_MARKETING_STORIES_ADD, ROUTE_MARKETING_STORIES_EDIT ]}
          exact
        >
          <PageWithSidebar>
            <StoryFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route
          path={[ ROUTE_MARKETING_LABEL_ADD, ROUTE_MARKETING_LABEL_EDIT ]}
          exact
        >
          <PageWithSidebar>
            <LabelFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route
          path={[ ROUTE_MARKETING_LOYALTY_COUPON_ADD, ROUTE_MARKETING_LOYALTY_COUPON_EDIT ]}
          exact
        >
          <PageWithSidebar>
            <LoyaltyCouponSeriesFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('settings') && (
        <Route path={ROUTE_SETTINGS} exact>
          <PageWithSidebar>
            <SettingsPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('settings') && (
        <Route path={ROUTE_SETTINGS_MENUS} exact>
          <PageWithSidebar>
            <MenusPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('settings') && (
        <Route 
          path={[ ROUTE_SETTINGS_MENUS_CREATE, ROUTE_SETTINGS_MENUS_EDIT ]} 
          exact
        >
          <PageWithSidebar>
            <MenuEditPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('settings') && (
        <Route path={ROUTE_SETTINGS_MENU_ITEMS} exact>
          <PageWithSidebar>
            <MenuItemsPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('settings') && (
        <Route path={ROUTE_SETTINGS_TOPOLOGY} exact>
          <PageWithSidebar>
            <TopologyPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('settings') && (
        <Route 
          path={[ ROUTE_SETTINGS_TOPOLOGY_COUNTRY_CREATE, ROUTE_SETTINGS_TOPOLOGY_COUNTRY_EDIT ]} 
          exact
        >
          <PageWithSidebar>
            <CountryFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('settings') && (
        <Route 
          path={[ ROUTE_SETTINGS_TOPOLOGY_REGION_CREATE, ROUTE_SETTINGS_TOPOLOGY_REGION_EDIT ]} 
          exact
        >
          <PageWithSidebar>
            <RegionFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('settings') && (
        <Route 
          path={[ ROUTE_SETTINGS_TOPOLOGY_CITY_CREATE, ROUTE_SETTINGS_TOPOLOGY_CITY_EDIT ]} 
          exact
        >
          <PageWithSidebar>
            <CityFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route path={ROUTE_MAIN_PAGE_CONFIGS } exact>
          <PageWithSidebar>
            <MainPageConfigsPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('marketing') && (
        <Route 
          path={[ ROUTE_MAIN_PAGE_CONFIGS_EDIT, ROUTE_MAIN_PAGE_CONFIGS_ADD ]} 
          exact
        >
          <PageWithSidebar>
            <MainPageConfigFormPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('devices') && (
        <Route
          path={[ ROUTE_DEVICES ]}
          exact
        >
          <PageWithSidebar>
            <DevicesPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('storage') && (
        <Route
          path={[ ROUTE_STORAGE_CONTAINERS ]}
          exact
        >
          <PageWithSidebar>
            <StorageContainersPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('storage') && (
        <Route
          path={[ ROUTE_STORAGE_CONTAINERS_CREATE ]}
          exact
        >
          <PageWithSidebar>
            <CreateStorageContainerPage />
          </PageWithSidebar>
        </Route>
      )}

      { canViewBlock('storage') && (
        <Route
          path={[ ROUTE_STORAGE_CONTAINERS_EDIT ]}
          exact
        >
          <PageWithSidebar>
            <EditStorageContainerPage />
          </PageWithSidebar>
        </Route>
      )}
      
      <Route path={ROUTE_ANY}>
        <PageWithSidebar>
          <NotFoundPage />
        </PageWithSidebar>
      </Route>

    </Switch>
  )
}
